export const AWS = process.env.REACT_APP_AWS_S3_URL as string;

export const LITTLESIZE = 200;
export const BIGSIZE = 1200;
